// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal .edit-line-component{margin-top:0}#modal .edit-line-component .subtitle{color:#7b8794;font-size:16px}#modal .edit-line-component .txt{margin-top:20px;color:#51606d;font-size:14px}#modal .edit-line-component .buttons{margin-top:60px}\n", ""]);
// Exports
module.exports = exports;
